/**
 * MODULE: _shared/lib/frontend/api/crmAccountHealthApi.ts
 * PURPOSE: HTTP client for CRM composite customer health (/api/v1/crm/accounts/{id}/health)
 * PUBLIC_API: crmGetAccountHealth, CrmAccountHealth, CrmHealthComponent
 * SIDE_EFFECTS: fetch to API gateway
 * AGENT_SAFETY: RESTRICTED
 */

import { API_CONFIG, getAuthHeaders } from './config';

export type CrmHealthTier = 'healthy' | 'watch' | 'at_risk';

export type CrmHealthComponent = {
  id: string;
  label: string;
  score: number;
  weight: number;
  detail: string;
};

export type CrmAccountHealth = {
  score: number;
  tier: CrmHealthTier;
  components: CrmHealthComponent[];
  salesIntelligenceScore?: number | null;
  computedAtISO?: string;
};

export async function crmGetAccountHealth(accountId: string): Promise<CrmAccountHealth> {
  const res = await fetch(
    `${API_CONFIG.baseURL}/api/v1/crm/accounts/${encodeURIComponent(accountId)}/health`,
    { headers: getAuthHeaders() }
  );
  if (!res.ok) {
    const t = await res.text();
    throw new Error(t || res.statusText);
  }
  return (await res.json()) as CrmAccountHealth;
}
